import { useState } from 'react';
import DashboardLayout from '../../../../commons/DashboardLayout/DashboardLayout';
import DashboardProspectionsTable from './DashboardProspectionsTable/DashboardProspectionsTable';
import Modal from '../../../../commons/Modal/Modal';
import DashboardProspectionsForm from './DashboardProspectionsForm/DashboardProspectionsForm';

export default () => {

  const [isModalOpen, setModalOpen] = useState(false);

  return (
    <>
      <DashboardLayout>
        <DashboardProspectionsTable openModal={() => setModalOpen(true)} />
      </DashboardLayout>
      <Modal isOpen={isModalOpen} setOpen={setModalOpen} closeOnClickOutside>
        <DashboardProspectionsForm />
      </Modal>
    </>
  );
};
